import { useEffect } from "react";
import { useData } from "../hooks/useData";

// Dynamically sets document SEO meta tags from site.json + per-page overrides.
export default function Seo({ title, description }) {
  const { data: site } = useData("site");

  useEffect(() => {
    if (!site) return;
    const brand = site.siteName || "utipanagecy";
    const t = title ? `${title} — ${brand}` : site.seo.title;
    const d = description || site.seo.description;
    document.title = t;

    const set = (attr, key, val) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    };
    set("name", "description", d);
    set("name", "keywords", site.seo.keywords);
    set("name", "author", site.seo.author);
    set("property", "og:title", t);
    set("property", "og:description", d);
    set("property", "og:image", site.seo.ogImage);
    set("property", "og:type", "website");
    set("name", "twitter:card", "summary_large_image");
  }, [site, title, description]);

  return null;
}
